import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { fromEvent } from "rxjs/observable/fromEvent";

@Injectable()
export class NetworkService {
    private networkStatusChanged$: Subject<boolean> = new Subject<boolean>();

    public readonly networkStatusChange$ = this.networkStatusChanged$.asObservable();

    constructor() {
        const offline = fromEvent(window, 'offline');
        offline.subscribe(() => { this.networkStatusChanged$.next(navigator.onLine); });

        const online = fromEvent(window, 'online');
        online.subscribe(() => { this.networkStatusChanged$.next(navigator.onLine); });
    }
}



// WEBPACK FOOTER //
// ./src/providers/network-service.ts